import { TypedUseSelectorHook, useDispatch, useSelector, useStore } from 'react-redux';
import type { RootState, AppDispatch } from '../../redux/store';

export const useAppSelector: TypedUseSelectorHook<RootState> = useSelector;
export const useAppDispatch = () => useDispatch<AppDispatch>();
export const useAppStore = () => useStore<RootState>();
export const useIsMultiPortfolioTenant = (): boolean =>
    useSelector((state: RootState) => Boolean(state?.global?.globalConfig?.isMultiPortfolioTenant));

export { useGoalEditData } from './useGoalEditData';
export { useGoalTermTabs } from './useGoalTermTabs';
export { useTermFormFields } from './useTermFormFields';
export { useFundingTermScope } from './useFundingTermScope';
export { useFundingNavigatorTabs } from './useFundingNavigatorTabs';
export { usePlanOverview } from './usePlanOverview';
export { useStalePlanRefresh } from './useStalePlanRefresh';
